module.exports = __webpack_public_path__ + "img/back.3eaaa6e5.svg";